import axios from "@/api/axios";

const getMonitorInfo = (data) => {
    return axios
        .post('/admin/monitor/monitor-info', {monitor: data})
        .then(response => response.data)
}

const getNewRequests = (data) => {
    return axios
        .post('/admin/monitor/new-requests', {monitor: data})
        .then(response => response.data)
}

const getProgressRequests = (data) => {
    return axios
        .post('/admin/monitor/progress-requests', {monitor: data})
        .then(response => response.data)
}

const getNotaskDeals = (data) => {
    return axios
        .post('/admin/monitor/notask-deals', {monitor: data})
        .then(response => response.data)
}

const getActiveDeals = (data) => {
    return axios
        .post('/admin/monitor/active-deals', {monitor: data})
        .then(response => response.data)
}

const getNewTasks = (data) => {
    return axios
        .post('/admin/monitor/new-tasks', {monitor: data})
        .then(response => response.data)
}

const getOverdueTasks = (data) => {
    return axios
        .post('/admin/monitor/overdue-tasks', {monitor: data})
        .then(response => response.data)
}

const getActiveClients = (data) => {
    return axios
        .post('/admin/monitor/active-clients', {monitor: data})
        .then(response => response.data)
}

const getNodealClients = (data) => {
    return axios
        .post('/admin/monitor/nodeal-clients', {monitor: data})
        .then(response => response.data)
}

const getNotaskClients = (data) => {
    return axios
        .post('/admin/monitor/notask-clients', {monitor: data})
        .then(response => response.data)
}

const getListDeal = (data) => {
    return axios
        .post('/admin/monitor/list-deal',{monitor: data})
        .then(response => response.data)
}

const getListTask = (data) => {
    return axios
        .post('/admin/monitor/list-task',{monitor: data})
        .then(response => response.data)
}

const getDealsStage = (data) => {
    return axios
        .post('/admin/monitor/deals-stage',{monitor: data})
        .then(response => response.data)
}

const getMonitorHistory = (data) => {
    return axios
        .post('/admin/monitor/monitor-history',{monitor: data})
        .then(response => response.data)
}

const setOpened = (data) => {
    return axios
        .post('/admin/client/set-opened',{client: data})
        .then(response => response.data)
}

export default {
    getMonitorInfo,
    getNewRequests,
    getProgressRequests,
    getNotaskDeals,
    getActiveDeals,
    getNewTasks,
    getOverdueTasks,
    getActiveClients,
    getNodealClients,
    getNotaskClients,
    getListDeal,
    getListTask,
    getDealsStage,
    getMonitorHistory,
    setOpened
}